import React from "react";

// components
import CommonForm from "../Common/CommonForm";
import BaseApi from "../../utils/BaseApi";
import CommonStepper from "../Common/CommonStepper";

// icons
import {CircularProgress, Stack} from "@mui/joy";


class TaskEditPhase extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeStep: 0,
            revision: null,
            phases: null,
        }
        this.steps = [
            {
                order: 0,
                title: 'Ревизия',
            },
            {
                order: 1,
                title: 'Этап',
            },
        ]
    }

    async retrieveRevisions() {
        const url = `estimation_revision/`;
        const api = new BaseApi();
        const params = {
            opportunity: this.props.task.opportunity.id,
            current: true,
            page_size: 10000,
        };
        let response = await api.get(
            url,
            params
        );
        return response.data.results
    }

    async retrieveStep0(){
        let revisions = await this.retrieveRevisions()
        let formFields = [
            {
                name: 'revision',
                label: 'Ревизия',
                xs: 12,
                sm: null,
                md: null,
                lg: null,
                xl: null,
                required: true,
                default: null,
                type: 'select',
                options: revisions.map(
                    (revision) => ({
                        value: revision.id,
                        label: `#${revision.id}: ${revision.desc}`,
                    })
                )
            },
            {
                type: 'submit',
                label: 'Далее',
            },
        ]
        this.setState(
            {
                formFields: formFields,
            }
        );
    }

    async componentDidMount() {
        if (this.props.task.phase){
            this.setState(
                {
                    revision: this.props.task.phase.revision_fk.id,
                },
                this.retrievePhaseForm
            )
        }
        else {
            await this.retrieveStep0()
        }
    }

    async retrievePhaseForm(id){
        this.setState({
            formFields: null
        })
        let revision = this.state.revision
        if (revision) {
            const url = `estimation_phase/`;
            const api = new BaseApi();
            const params = {
                revision_fk: revision,
                is_active: true,
            }
            let response = await api.get(
                url,
                params
            );
            this.setState(
                {
                    formFields: [
                        {
                            name: 'phase',
                            label: 'Этап',
                            xs: 12,
                            sm: null,
                            md: null,
                            lg: null,
                            xl: null,
                            required: true,
                            default: this.props.task.phase?.id?this.props.task.phase?.id:null,
                            type: 'select',
                            options: response.data.results.map(
                                (p) => (
                                    {
                                    value: p.id,
                                    label: `#${p.id}: ${p.title}`,
                                    }
                                )),
                        },
                        {
                            type: 'submit',
                            label: 'Сохранить',
                        },
                    ],
                    phases: response.data.results,
                    activeStep: 1,
                }
            );
        }
    }

    async processStep0(form) {
        let revision = form.state.formData.get('revision');
        this.setState({
            revision: revision,
        }, this.retrievePhaseForm)
    }

    async processStep1(form) {
        let phase = form.state.formData.get('phase');
        const url = `task/${this.props.task.id}/`;
        const api = new BaseApi();
        let data = {
            phase: phase
        }
        let response = await api.patch(
            url,
            data
        );
        if (response.status === 200) {
            if (this.props.callBack){
                await this.props.callBack()
            }
        }
        return response
    }

    async setStep(order) {
        let formData = new FormData();
        let formFake = {'state': {'formData': formData}}
        if (order === 0){
            await this.retrieveStep0()
        }
        else {
            await this['processStep'+(order-1)](formFake)
        }
        this.setState(
            {activeStep: order}
        )
    }

    render() {
        if (!this.state.formFields) {
            return (<CircularProgress />)
        }
        if (this.state.activeStep === 0) {
            return (
                <Stack>
                    <CommonStepper
                        steps={this.steps}
                        activeStep={this.state.activeStep}
                        callBack={this.setStep.bind(this)}
                    />
                    <CommonForm
                        fields={this.state.formFields}
                        processForm={this.processStep0.bind(this)}
                    />
                </Stack>
            )
        }
        else if (this.state.activeStep === 1) {
            return (
                <Stack>
                    <CommonStepper
                        steps={this.steps}
                        activeStep={this.state.activeStep}
                        callBack={this.setStep.bind(this)}
                    />
                    <CommonForm
                        fields={this.state.formFields}
                        processForm={this.processStep1.bind(this)}
                    />
                </Stack>
            )
        }
    }
}

export default TaskEditPhase

